import React from 'react';

const NotificationList = () => {
  return (
    <div className="container mt-5">
      <h2>Notification Management</h2>
      <p>Notifications list and CRUD operations</p>
    </div>
  );
};

export default NotificationList;
